import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'datetime-termpicker',
    templateUrl: './datetime-termpicker.component.html',
    styleUrls: ['./datetime-termpicker.component.scss']
})
export class DatetimeTermpickerComponent implements OnInit, OnChanges {

    @Input() label = 'Zvolte datum';
    @Input() datepickerPlaceholder = 'Zvolte datum';

    @Input() fromDate: Date = new Date();
    @Input() toDate: Date = new Date();

    @Output() fromDateChange: EventEmitter<Date> = new EventEmitter<Date>();
    @Output() toDateChange: EventEmitter<Date> = new EventEmitter<Date>();

    @Output('change') update = new EventEmitter<any>();

    minDate = new Date();
    date = new Date();

    from = {
        hour: this.fromDate.getHours(),
        minute: this.fromDate.getMinutes()
    };
    to = {
        hour: this.toDate.getHours(),
        minute: this.toDate.getMinutes()
    };

    ngOnInit(): void {
        this.inputChange();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.inputChange();
    }

    inputChange(): void {
        this.date = new Date(this.fromDate.getTime());
        this.from = {
            hour: this.fromDate.getHours(),
            minute: this.fromDate.getMinutes()
        };
        this.to = {
            hour: this.toDate.getHours(),
            minute: this.toDate.getMinutes()
        };
        // this.from.hour = this.fromDate.getHours();
        // this.from.minute = this.fromDate.getMinutes();
        // this.to.hour = this.toDate.getHours();
        // this.to.minute = this.toDate.getMinutes();
    }

    termChanged(): void {
        this.fromDate.setDate(this.date.getDate());
        this.fromDate.setMonth(this.date.getMonth());
        this.fromDate.setFullYear(this.date.getFullYear());
        this.fromDate.setHours(this.from.hour);
        this.fromDate.setMinutes(this.from.minute);
        this.fromDate.setSeconds(0);
        this.fromDate.setMilliseconds(0);

        this.toDate.setDate(this.date.getDate());
        this.toDate.setMonth(this.date.getMonth());
        this.toDate.setFullYear(this.date.getFullYear());
        this.toDate.setHours(this.to.hour);
        this.toDate.setMinutes(this.to.minute);
        this.toDate.setSeconds(0);
        this.toDate.setMilliseconds(0);

        if (this.toDate.getTime() < this.fromDate.getTime()) {
            this.toDate.setTime(this.fromDate.getTime());

            this.to = {
                hour: this.from.hour,
                minute: this.from.minute
            };
        }

        this.fromDateChange.emit(new Date(
            this.fromDate.getFullYear(),
            this.fromDate.getMonth(),
            this.fromDate.getDate(),
            this.fromDate.getHours(),
            this.fromDate.getMinutes(),
            this.fromDate.getSeconds()
        ));

        this.toDateChange.emit(new Date(
            this.toDate.getFullYear(),
            this.toDate.getMonth(),
            this.toDate.getDate(),
            this.toDate.getHours(),
            this.toDate.getMinutes(),
            this.toDate.getSeconds()
        ));

        this.update.emit();
    }

}


//
// import {Component, EventEmitter, Input, Output} from '@angular/core';
// import {FormControl} from '@angular/forms';
//
// @Component({
//     selector: 'datetime-termpicker',
//     templateUrl: './datetime-termpicker.component.html',
//     styleUrls: ['./datetime-termpicker.component.scss']
// })
// export class DatetimeTermpickerComponent {
//     @Input() label = 'Zvolte datum';
//     @Input() datepickerPlaceholder = 'Zvolte datum';
//
//     @Input() fromDate: number = Date.now();
//     @Input() toDate: number = Date.now();
//
//     @Output() fromDateChange: EventEmitter<number> = new EventEmitter<number>();
//     @Output() toDateChange: EventEmitter<number> = new EventEmitter<number>();
//
//     minDate = new Date();
//     date = new Date();
//
//
//     // from = {
//     //     hour: this.fromDate.getHours(),
//     //     minute: this.fromDate.getMinutes()
//     // };
//     from = {
//         hour: (new Date(this.fromDate)).getHours(),
//         minute: (new Date(this.fromDate)).getMinutes()
//     }
//     // to = {
//     //     hour: this.toDate.getHours(),
//     //     minute: this.toDate.getMinutes()
//     // };
//     to = {
//         hour: (new Date(this.toDate)).getHours(),
//         minute: (new Date(this.toDate)).getMinutes()
//     }
//
//     termChanged(): void {
//         const fromDateTemp = new Date();
//         const toDateTemp = new Date();
//
//         fromDateTemp.setSeconds(0);
//         toDateTemp.setSeconds(0);
//
//         fromDateTemp.setDate(this.date.getDate());
//         fromDateTemp.setMonth(this.date.getMonth());
//         fromDateTemp.setFullYear(this.date.getFullYear());
//         fromDateTemp.setHours(this.from.hour);
//         fromDateTemp.setMinutes(this.from.minute);
//         fromDateTemp.setSeconds(0);
//         this.fromDate = fromDateTemp.getTime();
//
//         toDateTemp.setDate(this.date.getDate());
//         toDateTemp.setMonth(this.date.getMonth());
//         toDateTemp.setFullYear(this.date.getFullYear());
//         toDateTemp.setHours(this.to.hour);
//         toDateTemp.setMinutes(this.to.minute);
//         toDateTemp.setSeconds(0);
//         this.toDate = toDateTemp.getTime();
//
//         if (this.toDate < this.fromDate) {
//             this.toDate = this.fromDate;
//             // this.toDate.setTime(this.fromDate.getTime());
//
//             this.to = {
//                 hour: this.from.hour,
//                 minute: this.from.minute
//             };
//         }
//
//         this.fromDateChange.emit(Math.floor(this.fromDate / 1000));
//
//         this.toDateChange.emit(Math.floor(this.fromDate / 1000));
//     }
//
// }



// WEBPACK FOOTER //
// /app/src/SharedModule/DatetimeTermpickerComponent/datetime-termpicker.component.ts